import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import LineDotBothHandler from "./LineDotBothHandler";
import SecondGraph from "./SecondGraph";
import Internationl2 from "./Internationl2";
import styles from "./styles";
import "animate.css/animate.css";

const GraphLineDot = (props) => {
  const {
    classes,
    questionAnswer,
    setAnsweredCorrectly,
    setAnsweredPartialy,
    setAnswers,
    setPhase2Answers,
    setPhase3Answers,
    answers,
    phase2Answers,
    phase3Answers,
    answeredCorrectly,
    submitted,
    nextStageSubmitted,
    secondStage,
    correctAnswer,
    selectedOption,
  } = props;

  return (
    <Grid
      className={classes.quizContainer}
      style={{ marginRight: questionAnswer.model > 3 && secondStage && 0 }}
    >
      <Grid className={classes.leftDiv}>
        <Typography
          variant="h5"
          align="center"
          className={
            questionAnswer.type == "international"
              ? classes.questionTitleInternational
              : classes.questionTitle
          }
        >
          {questionAnswer.title}
        </Typography>
      </Grid>
      <Grid
        className={classes.graphDiv}
        style={{ marginBottom: nextStageSubmitted && "0px" }}
      >
        <Grid container className={classes.graphDiv2}>
          {questionAnswer.type === "international" ? (
            <SecondGraph
              submitted={submitted}
              setAnsweredCorrectly={setAnsweredCorrectly}
              setAnsweredPartialy={setAnsweredPartialy}
              questionAnswer={questionAnswer}
              setPhase2Answers={setPhase2Answers}
              setAnswers={setAnswers}
              answers={answers}
              phase2Answers={phase2Answers}
              selectedOption={selectedOption}
            />
          ) : questionAnswer.type === "international2" ? (
            <Internationl2
              submitted={submitted}
              setAnsweredCorrectly={setAnsweredCorrectly}
              setAnsweredPartialy={setAnsweredPartialy}
              questionAnswer={questionAnswer}
              setAnswers={setAnswers}
              answers={answers}
              selectedOption={selectedOption}
            />
          ) : (
            <LineDotBothHandler
              setAnsweredPartialy={setAnsweredPartialy}
              submitted={submitted}
              setAnsweredCorrectly={setAnsweredCorrectly}
              questionAnswer={questionAnswer}
              setAnswers={setAnswers}
              answers={answers}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(GraphLineDot);
